<template>
  <div>
    <v-tooltip bottom v-if="tooltipText">
      <template v-slot:activator="{ on: tooltip }">
        <div v-on="{ ...tooltip }">
          <v-btn
            :class="buttonClass"
            :small="buttonSmall"
            :color="buttonColor"
            :disabled="disabled"
            @click.stop="dialog = true"
            v-on="{ ...tooltip }"
          >
            <v-icon>{{ buttonIcon }}</v-icon>
          </v-btn>
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <LoadIcon v-if="loading" mt="35" ml="30" style="z-index: 999" />
      <v-card width="700px" :disabled="loading">
        <v-card-title class="headline mb-0 pb-0"
          >{{ dialogTitle }}
        </v-card-title>

        <v-card-text class="my-0 py-0">
          <v-row>
            <v-col class="my-0 py-0">
              <v-text-field
                :label="this.$t('kiosks.pathFilter')"
                v-model="pathFilter"
                :append-icon="'mdi-close'"
                @click:append="() => (pathFilter = '')"
                :prepend-icon="'mdi-filter-outline'"
              />
            </v-col>
          </v-row>
          <v-row>
            <DirList
              v-model="folderList"
              :selectedCount="selectedCount"
              :height="height > 800 ? 800 : height"
              v-on:fileSelectionChanged="fileSelectionChanged"
            />
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="onCancel">
            {{ cancelText }}
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="onOk"
            :disabled="okDisabled"
          >
            {{ okText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import DragForm from '@/components/Forms/DragForm.vue';
import LoadIcon from '@/components/LoadIcon';
import DirList from './DirList.vue';
import Vue from 'vue';

export default {
  components: {
    DragForm,
    LoadIcon,
    DirList,
  },
  props: {
    buttonClass: {
      type: String,
      default: 'mr-1',
    },
    buttonIcon: {
      type: String,
      default: '',
    },
    buttonDark: {
      type: Boolean,
      default: true,
    },
    buttonSmall: {
      type: Boolean,
      default: true,
    },
    buttonColor: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dialogMaxWidth: {
      type: String,
      default: '400px',
    },
    tooltipText: {
      type: String,
      defaultItem: null,
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogText: {
      type: String,
      default: '',
    },
    okText: {
      type: String,
      default: 'Agree',
    },
    cancelText: {
      type: String,
      default: 'Disagree',
    },
    onOkAction: {
      type: Function,
    },
    kioskId: {
      type: String,
    },
  },
  data() {
    return {
      dialog: false,
      wasBlurred: false,
      okButtonClick: false,
      loading: false,
      folderList: {},
      selectedFiles: new Set(),
      selectedCount: 0,
      mediaFilesResp: [],
      pathFilter: '',
      heightTmp: 0,
      height: 0,
      testData: [
        {
          Photo: [
            'Humo.png',
            'Humo_old.png',
            'Mastercard_old.png',
            'Platinum.png',
            'Uzcard.png',
            'Uzcard_old.png',
            'World.png',
            {
              PhotoInner: [
                'Humo.png',
                'Humo_old.png',
                'Mastercard_old.png',
                'Platinum.png',
                'Uzcard.png',
                'Uzcard_old.png',
                'World.png',
              ],
            },
          ],
        },
        {
          Video: [
            '061223_1244_kekov_kek4.mp4',
            '061223_1248_kekov_kek4.mp4',
            '061223_1253_kekov_kek4.mp4',
            'CardKioskServiceSetup.msi',
          ],
        },
        'TestFile-100.txt',
        'TestFile-101.txt',
        'TestFile-102.txt',
      ],
    };
  },
  watch: {
    dialog(flag) {
      if (!flag) this.clear();
      else {
        this.folderList = {};
        this.getData();
      }
    },
    pathFilter() {
      this.onFilterChanged(this.folderList, this.pathFilter);
    },
  },
  computed: {
    okDisabled() {
      return this.selectedCount <= 0;
    },
  },
  methods: {
    getData() {
      this.loading = true;

      this.$axios.kiosks
        .checkMedia({ kioskId: this.kioskId })
        .then((resp) => resp.data)
        .then((mediaFiles) => {
          this.mediaFilesResp = mediaFiles;
          this.heightTmp = 40;
          this.folderList = this.newFolderObj('', 'root', true);
          this.convertPaths(this.mediaFilesResp, this.folderList);
          var max = Math.round((window.innerHeight - 156) * 0.85);
          this.height = this.heightTmp < max ? this.heightTmp : max;
          this.loading = false;
        })
        .catch((error) => {
          this.onError('', 'Error get data', error);
          this.dialog = false;
        });
    },

    newFolderObj(name, fullPath, isVisible = false) {
      return {
        name: name,
        fullPath: fullPath,
        isSelected: 0,
        isVisible: isVisible,
        folders: [],
        files: [],
      };
    },
    newConvertRes(isVisible, isSelected) {
      return {
        isVisible: isVisible,
        isSelected: isSelected,
      };
    },

    convertPaths(paths, res, path) {
      if (typeof paths === 'string') return this.handleFile(paths, res, path);
      else if (Array.isArray(paths))
        return this.handleFolderContent(paths, res, path);

      return this.handleFolder(paths, res, path);
    },

    handleFile(filename, res, path) {
      var filePath = path + '/' + filename;
      var isSelected = this.selectedFiles.has(filePath);
      var isVisible =
        this.pathFilter === '' || filePath.includes(this.pathFilter);

      var fileInfo = {
        isSelected: isSelected ? 2 : 0,
        name: filename,
        isVisible: isVisible,
      };

      res.files.push(fileInfo);
      this.heightTmp += 40;

      return this.newConvertRes(isVisible, isSelected);
    },
    handleFolderContent(paths, res, path) {
      var partSelectedCount = 0;
      var fullSelectedCount = 0;
      var visibleCount = 0;

      paths.forEach((val) => {
        var convRes = this.convertPaths(val, res, path);

        if (convRes.isVisible) {
          res.isVisible = true;
          visibleCount++;

          if (convRes.isSelected == 1) partSelectedCount++;
          else if (convRes.isSelected == 2) fullSelectedCount++;
        }
      });

      var isSelected = 0;
      if (visibleCount > 0) {
        if (visibleCount == fullSelectedCount) isSelected = 2;
        else if (partSelectedCount > 0) isSelected = 1;
      }
      res.isSelected = isSelected;

      return this.newConvertRes(res.isVisible, res.isSelected);
    },
    handleFolder(folderData, res, path) {
      var name = Object.keys(folderData)[0];
      var value = folderData[name];

      var folder = this.newFolderObj(name, res.fullPath + '/' + name);

      this.heightTmp += 40;
      res.folders.push(folder);

      return this.convertPaths(value, folder, path + '/' + name);
    },

    onFilterChanged(folderInfo, filter, rootPath = '') {
      var partSelectedCount = 0;
      var fullSelectedCount = 0;
      var visibleCount = 0;
      var fullPath = rootPath + '/' + folderInfo.name;

      folderInfo.folders.forEach((folder) => {
        var foldRes = this.onFilterChanged(folder, filter, fullPath);

        if (foldRes.isVisible) {
          visibleCount++;
          if (foldRes.isSelected == 2) fullSelectedCount++;
          else if (foldRes.isSelected == 1) partSelectedCount++;
        }
      });

      folderInfo.files.forEach((file) => {
        var fileName = fullPath + '/' + file.name;
        var fVisible = fileName.includes(filter);

        if (fVisible) {
          visibleCount++;
          if (file.isSelected == 2) fullSelectedCount++;
          file.isVisible = true;
        } else {
          file.isVisible = false;
        }
      });

      if (visibleCount == 0) {
        folderInfo.isVisible = false;
      } else {
        folderInfo.isVisible = true;

        if (visibleCount == fullSelectedCount) {
          folderInfo.isSelected = 2;
        } else if (partSelectedCount > 0 || fullSelectedCount > 0) {
          folderInfo.isSelected = 1;
        } else {
          folderInfo.isSelected = 0;
        }
      }

      return this.newConvertRes(folderInfo.isVisible, folderInfo.isSelected);
    },

    async onOk() {
      this.okButtonClick = true;

      if (this.okButtonClick) {
        this.loading = true;

        var data = [];
        this.setFilesToData(this.folderList, data);

        await this.onOkAction(data);

        this.loading = false;

        this.dialog = false;
      }
    },

    setFilesToData(folderInfo, data) {
      if (folderInfo.folders.length > 0) {
        folderInfo.folders.forEach((folder) => {
          var folderRes = {};
          folderRes[folder.name] = [];

          this.setFilesToData(folder, folderRes[folder.name]);

          if (folderRes[folder.name].length > 0) {
            data.push(folderRes);
          }
        });
      }

      if (folderInfo.files.length > 0) {
        folderInfo.files.forEach((file) => {
          if (file.isSelected == 2) {
            data.push(file.name);
          }
        });
      }
    },

    onCancel() {
      this.$emit('cancel');

      this.dialog = false;
    },

    clear() {
      this.loading = false;

      this.pathFilter = '';
      this.height = 0;
      this.heightTmp = 0;
      this.clearSelected();
    },
    clearSelected() {
      this.selectedCount = 0;
      this.selectedFiles.clear();
    },

    fileSelectionChanged(val, filepath) {
      if (val == 2 && !this.selectedFiles.has(filepath)) {
        this.selectedCount++;
        this.selectedFiles.add(filepath);
      } else if (val === 0 && this.selectedFiles.has(filepath)) {
        this.selectedCount--;
        this.selectedFiles.delete(filepath);
      }
    },

    onError(title, text, error) {
      console.error(error);

      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: 'error',
      });
    },
  },

  mounted() {
    this.clear();
  },
};
</script>
